import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { FetchBranchShowData, LocationShowdata, StudentUserAdd, StudentUserUpdate } from '../../services/LoginPageService';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const StudentUserModel = ({open, setOpen, isAddButton, editStudentUser,setRefreshData,setNotification}) => {
    const [location,setLocation]=useState('');
    const [locationList,setLocationList]=useState([]);
    const [LocDisabled,setLocDisabled] = useState(false);
    const[branch,setBranch]=useState('');
    const[branchList,setBranchList]=useState([]);
    const [emailId,setEmailId]=useState('');
    const [password,setPassword]=useState('');
    const [phonoNo,setPhonoNo]=useState('');
    const [userName,setUserName]=useState('');
    const [designation,setDesignation]=useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isNewUser, setIsNewUser] = useState(false);

    const handleClose = () => {
        setOpen(false);
        clearForm();
        setPassword('');
    };

    useEffect(()=>{
        LocationShowdata(handleLocationshow,handleLocationshowException);
         setLocation(editStudentUser?.locationId || '');
        setBranch(editStudentUser?.branchId || '');
        setEmailId(editStudentUser?.email || '');
        // setPassword(editStudentUser?.password || '');
        setPhonoNo(editStudentUser?.phone || '');
        setUserName(editStudentUser?.fullName || '');
        setDesignation(editStudentUser?.userRole || '');
        setShowPassword(false); // Clear the showPassword state

        if (isAddButton) {
            setPassword('');
        } else {
            setPassword(editStudentUser?.password || '');
        }
        
        // if(editStudentUser)
        // {
        //     SelectionDisabled();
        // }
    },[editStudentUser])

    const SelectionDisabled = ()=>{
        setLocDisabled(true);
    }

    const handleLocationshow=(dataObject)=>{
        setLocationList(dataObject?.data);
        console.log(dataObject?.data);
        if(editStudentUser?.locationId)
        {
            FetchBranchShowData({id:editStudentUser?.locationId},handleBranchSuccess, handleBranchException);
        }
    }

    const handleLocationshowException=(error,errorMessage)=>{
        console.log(errorMessage);
    }

    const onLocationChange=(e)=>{
        setLocation(e.target.value);
        FetchBranchShowData({id:e.target.value},handleBranchSuccess, handleBranchException);
    }

    const handleBranchSuccess = (dataObject) =>{
        console.log('data Branch');
        setBranchList(dataObject.data);
    }
      
    const handleBranchException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onBranchChange=(e)=>{
        setBranch(e.target.value);
    }

    const handleDesignationChange = (event) => {
        setDesignation(event.target.value);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (!isValidEmail(emailId)) {
            // Show an error notification for an invalid email
            setNotification({
              status: true,
              type: 'error',
              message: 'Invalid email address. Please enter a valid email.',
            });
            return; // Prevent form submission
          }
        isAddButton === true ?
        
        (
            StudentUserAdd({
                location:location,
                branch:branch,
                fullName:userName,
                email:emailId,
                password:password,
                phone:phonoNo,
                userRole:designation,
            }, handleAddSuccess, handleException)
        ) : (
            StudentUserUpdate({
                id:editStudentUser.id,
                location:location,
                branch:branch,
                fullName:userName,
                email:emailId,
                password:password,
                phone:phonoNo,
                userRole:designation,
          }, handleUpdateSuccess, handleException)
        );
    }

    const handleAddSuccess = (dataObject) => {
        console.log(dataObject); 
        setNotification({
          status: true,
          type: 'success',
          message: dataObject.message,
        });
        setTimeout(() => {
            setOpen(false);
        }, 2000);
        setRefreshData(oldValue => !oldValue);
        clearForm();
    }

    const clearForm = () => {
        setLocation('');
        setBranch('');
        setUserName('');
        setEmailId('');
        setPassword('');
        setPhonoNo('');
        setDesignation('');
        setLocDisabled(false);
        setRefreshData(oldValue => !oldValue);
    } 

    const handleUpdateSuccess = (dataObject) => {
        console.log(dataObject);
        setNotification({
          status: true,
          type: 'success',
          message: dataObject.message,
        });
        setTimeout(() => {
            setOpen(false);
        }, 2000);
        setRefreshData(oldValue => !oldValue);
        clearForm();
    }

    const handleException = (errorObject, errorMessage) => {
        console.log(errorMessage);
        setNotification({
          status: true,
          type: 'error',
          message: errorMessage,
        });
        setLocation('');
        setBranch('');
        setUserName('');
        setEmailId('');
        setPassword('');
        setPhonoNo('');
        setDesignation('');
        clearForm();
    }

    const isValidEmail = (email) => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
      };

      const isValidInput = (inputValue) => {
        // Regular expression to validate the input: only allow letters and spaces
        const regex = /^[A-Za-z\s]+$/;
        return regex.test(inputValue);
      };
    

      const handleUsernameChange = (e) => {
        const inputValue = e.target.value;
        if (isValidInput(inputValue)) {
          setUserName(inputValue);
        } else {
          // Check if the input value is empty after backspace, then clear the location
          if (inputValue === '') {
            setUserName('');
          }
        }
      };

    return (
        <div>
            <Dialog
            sx={{ '& .MuiDialog-paper': { width: '35%', maxHeight: '100%' } }}
            maxWidth="lg"
            open={open}>
                <form onSubmit={onSubmit}>
                    <DialogTitle style={{background:'#f7f7f7',color:'black'}}>
                        {isAddButton === true ? 'Add ' : 'Update '}User
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} style={{marginTop:'10px'}}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Location</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Location"
                                    placeholder='Location'
                                    value={location}
                                    disabled ={LocDisabled}
                                    required
                                    onChange={(e) => onLocationChange(e) }>
                                    {
                                        locationList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.location}</MenuItem>
                                            )
                                        })
                                    }      
                                    
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Hostel Name</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Hostel Name"
                                    placeholder='Hostel Name'
                                    value={branch}
                                    onChange={(e) => onBranchChange(e) }>
                                        {
                                            branchList.length !== 0 ? (

                                            <MenuItem value="" key={0}>
                                            <em>Select Hostel Name</em>
                                            </MenuItem>
                                            )
                                        :
                                         (   <MenuItem value="" key={0}>
                                            <em>Select Location </em>
                                            </MenuItem>
                                        )}
                                    {
                                        branchList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.branch}</MenuItem>
                                            )
                                        })

                                    }      
                                    
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                fullWidth
                                label="Username"
                                placeholder='Username'
                                variant="outlined"
                                required
                                onChange={handleUsernameChange}
                                // onChange={(e) => { setUserName(e.target.value) }}
                                value={userName}/>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                            fullWidth
                            label="Email Id"
                            placeholder="Email Id"
                            variant="outlined"
                            required
                            error={emailId !== '' && !isValidEmail(emailId)} // Check for error condition
                            helperText={emailId !== '' && !isValidEmail(emailId) ? 'Invalid email address' : ''}
                            onChange={(e) => setEmailId(e.target.value)}
                            value={emailId}
                            />
                            </Grid>
                            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                            fullWidth
                            label="Password"
                            placeholder="Password"
                            variant="outlined"
                            required
                            type={isAddButton ? (showPassword ? 'text' : 'password') : 'password'}
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                            value={password}
                            InputProps={{
                                endAdornment: (
                                <IconButton onClick={() => setShowPassword((prevShowPassword) => !prevShowPassword)} edge="end">
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                                ),
                            }}
                            autoComplete="off"
                            />

                            </Grid> */}
                             <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                fullWidth
                                label="Password"
                                placeholder='Password'
                                variant="outlined"
                                required
                                onChange={(e) => { setPassword(e.target.value) }}
                                value={password}/>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                fullWidth
                                label="Phone No"
                                placeholder='Phone No'
                                variant="outlined"
                                
                                onChange={(e) => { setPhonoNo(e.target.value) }}
                                value={phonoNo}/>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Designation</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Designation"
                                    placeholder='Designation'
                                    required
                                    value={designation}
                                    onChange={handleDesignationChange}>
                                    <MenuItem value={'Admin'}>Admin</MenuItem>
                                    <MenuItem value={'Principal'}>Principal</MenuItem>
                                    <MenuItem value={'Hod'}>HOD</MenuItem>
                                    <MenuItem value={'Faculty'}>Faculty </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button type='submit'>
                            {
                                isAddButton ? 'Add' : 'update'
                            }
                        </Button>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </form>
            </Dialog>
        
        </div>
    )
}

export default StudentUserModel
